import { Carousel, FranchiseCard } from '@design-system';

import { formatPostCount } from '../../utils/journals/insights';

interface Props {
  entrypoints?: EntrypointCard[];
  indexCounts: number[];
}

export const FranchiseEntrypoints = ({
  entrypoints = [],
  indexCounts = [],
}: Props) => {
  return (
    <Carousel
      arrowPosition="middle"
      items={entrypoints.map((entrypoint, index) => (
        <FranchiseCard
          key={entrypoint._uid}
          description={`${formatPostCount(indexCounts[index])} ${
            entrypoint.subtitle
          }`}
          href={`/${entrypoint.link.cached_url}1`}
          image={entrypoint.image}
          title={entrypoint.title}
        />
      ))}
      perPage={4}
    />
  );
};
